/*
  Carrito sin salir de la página · Ferretería La Obra · 30 oct 2026
  Lo carga sections/lo-carrito-sin-salir.liquid (grupo del encabezado). Hace tres cosas:

  1. «Agregar al carrito» ya no lleva a la página del carrito.
     assets/product-form.js busca un elemento <cart-notification>; la sección pone uno vacío (.lo-cs-gancho)
     y aquí se le dan los tres métodos que usa: getSectionsToRender, setActiveElement y renderContents.
     El tema agrega igual que siempre (mismo /cart/add, mismos eventos de Shopify y del píxel) y aquí se abre
     la ventana «Se agregó a su carrito». «Ver carrito y pagar» y «Ver carrito» llevan a la página del carrito.

  2. Ficha del producto: barra de agregado rápido (#custom-sticky-bar).
     Antes de agregar aparece al pasar el botón principal, con el precio, «Envío gratis» y «Llega el jueves 5»
     (31 oct 2026; misma regla que «Estimación de envío» de la ficha). Con el producto en el carrito muestra «En su carrito»,
     el total, la cantidad (bote de basura en 1, tope en las existencias) y «Ver carrito».
     La barra anterior (v7, al final de sections/main-product.liquid) no arranca: su script encuentra primero
     esta barra (mismo id y data-laobra-init="1") y se detiene; aquí se retira su marcado.
     lo-ir-arriba.liquid (flecha y chat) y lo-detalles.liquid (espacio al final y cajones) siguen con esta barra.

  3. Demás páginas, hasta 989 px: barra del carrito mientras tiene productos.

  Los cambios que hacen otros botones (bolsita de las tarjetas, «Agregar» de la lista en celular) se detectan
  al terminar su petición al carrito y se actualizan el contador del encabezado y la barra.
  31 oct 2026: al volver con «atrás» o con «Regresar y seguir comprando» (que usa history.back), el navegador
  puede mostrar la página guardada con el carrito de antes (por ejemplo, el contador en 7 con el carrito ya
  vacío). Por eso el contador y la barra se vuelven a pedir en cuanto la página regresa, si se precargó o
  si la pestaña vuelve a verse; la petición no usa la caché del navegador.
  Para regresar a como estaba: desactive la sección «Carrito sin salir» del encabezado en el editor.
*/
(function () {
  'use strict';

  var datosEl = document.getElementById('lo-cs-datos');
  if (!datosEl || window.loCarrito || !window.fetch) return;

  var D;
  try {
    D = JSON.parse(datosEl.textContent);
  } catch (error) {
    return;
  }

  var barra = document.querySelector('#custom-sticky-bar.lo-cs');
  var gancho = document.querySelector('cart-notification.lo-cs-gancho');
  var RAIZ = D.raiz || '/';
  var URL_CARRITO = D.carrito || '/cart';
  var UMBRAL = Number(D.umbral) || 0;
  var SECCIONES = 'cart-icon-bubble,lo-carrito-estado';
  var PUB = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
  var fetchOriginal = window.fetch.bind(window);
  var estado = normalizar(D.estado);
  var producto = D.producto && D.producto.variantes && D.producto.variantes.length ? D.producto : null;
  var modo = '';
  if (barra) modo = barra.hasAttribute('data-lo-general') ? 'general' : producto ? 'ficha' : '';
  var anchoGeneral = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: true };
  var BOTONES = '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

  var el = {};
  var hoja = null;
  var hojaCaja = null;
  var hojaAbierta = false;
  var activoAntes = null;
  var yaTiene = null;
  var pasado = false;
  var oculta = false;
  var avisoTexto = '';
  var esperaAviso = null;
  var esperaRefresco = null;
  var avisoPendiente = false;
  var ultimoRefresco = Date.now();
  var esperaCambio = null;
  var cantidadPedida = null;
  var clavePedida = null;
  var esperaCarga = null;
  var desdeBarra = 0;
  var tostada = null;
  var esperaTostada = null;
  var ioBoton = null;
  var io = null;
  var sincronizando = false;

  window.loCarrito = {
    refrescar: function () {
      refrescar(false);
    }
  };

  var ICONO = {
    carrito:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>',
    palomita:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"></path></svg>',
    camion:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="1" y="3" width="15" height="13" rx="1.5"></rect><path d="M16 8h4l3 3v5h-7z"></path><circle cx="5.5" cy="18.5" r="2"></circle><circle cx="18.5" cy="18.5" r="2"></circle></svg>',
    bote:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 7h16"></path><path d="M9 7V4.5h6V7"></path><path d="M6.5 7l.9 12.2a1.5 1.5 0 0 0 1.5 1.3h6.2a1.5 1.5 0 0 0 1.5-1.3L17.5 7"></path><path d="M10 11v6M14 11v6"></path></svg>',
    menos:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"></path></svg>',
    mas:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"></path></svg>',
    flecha:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"></path></svg>',
    cerrar:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"></path></svg>'
  };

  /* ---------- Datos del carrito ---------- */
  function normalizar(c) {
    if (!c || typeof c !== 'object') c = {};
    if (!Array.isArray(c.items)) c.items = [];
    c.item_count = Number(c.item_count) || 0;
    c.total_price = Number(c.total_price) || 0;
    return c;
  }

  function lineaDeVariante(id) {
    for (var i = 0; i < estado.items.length; i++) {
      if (String(estado.items[i].variant_id) === String(id)) return estado.items[i];
    }
    return null;
  }

  function lineaPorClave(clave) {
    for (var i = 0; i < estado.items.length; i++) {
      if (estado.items[i].key === clave) return estado.items[i];
    }
    return null;
  }

  function articulos(n) {
    return n === 1 ? '1 artículo' : n + ' artículos';
  }

  /* ---------- Dinero con el formato de la tienda ($ {{amount}}) ---------- */
  var FORMATO = (function () {
    var caja = document.createElement('div');
    caja.innerHTML = String(D.formato || '$ {{amount}}');
    return caja.textContent || '$ {{amount}}';
  })();

  function separarMiles(numero, separador) {
    var s = String(numero);
    var fuera = '';
    while (s.length > 3) {
      fuera = separador + s.slice(s.length - 3) + fuera;
      s = s.slice(0, s.length - 3);
    }
    return s + fuera;
  }

  function dinero(centavos) {
    var c = Math.round(Number(centavos) || 0);
    var signo = c < 0 ? '-' : '';
    c = Math.abs(c);
    var entero = Math.floor(c / 100);
    var decimales = String(c % 100);
    if (decimales.length < 2) decimales = '0' + decimales;
    var redondo = Math.round(c / 100);
    var ini = FORMATO.indexOf('{{');
    var fin = FORMATO.indexOf('}}', ini);
    var clave = ini > -1 && fin > ini ? FORMATO.slice(ini + 2, fin).trim() : 'amount';
    var monto;
    if (clave === 'amount_no_decimals') monto = separarMiles(redondo, ',');
    else if (clave === 'amount_with_comma_separator') monto = separarMiles(entero, '.') + ',' + decimales;
    else if (clave === 'amount_no_decimals_with_comma_separator') monto = separarMiles(redondo, '.');
    else if (clave === 'amount_with_apostrophe_separator') monto = separarMiles(entero, "'") + '.' + decimales;
    else monto = separarMiles(entero, ',') + '.' + decimales;
    if (ini < 0 || fin < ini) return signo + '$ ' + monto;
    return signo + FORMATO.slice(0, ini) + monto + FORMATO.slice(fin + 2);
  }

  /* ---------- Secciones que devuelve Shopify junto con el carrito ---------- */
  function documentoDe(html) {
    if (typeof html !== 'string' || !html) return null;
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function aplicarSecciones(secciones) {
    if (!secciones) return false;
    var burbuja = document.getElementById('cart-icon-bubble');
    var docBurbuja = documentoDe(secciones['cart-icon-bubble']);
    var interior = docBurbuja && docBurbuja.querySelector('.shopify-section');
    if (burbuja && interior) burbuja.innerHTML = interior.innerHTML;

    var docEstado = documentoDe(secciones['lo-carrito-estado']);
    var guion = docEstado && docEstado.querySelector('script[data-lo-carrito-estado]');
    if (!guion) return false;
    try {
      estado = normalizar(JSON.parse(guion.textContent));
      return true;
    } catch (error) {
      return false;
    }
  }

  function refrescar(conAviso, inmediato) {
    if (conAviso) avisoPendiente = true;
    clearTimeout(esperaRefresco);
    esperaRefresco = setTimeout(function () {
      ultimoRefresco = Date.now();
      var piezasAntes = estado.item_count;
      fetchOriginal(RAIZ + '?sections=' + SECCIONES, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      })
        .then(function (respuesta) {
          return respuesta.ok ? respuesta.json() : null;
        })
        .then(function (secciones) {
          if (!secciones) return;
          aplicarSecciones(secciones);
          if (avisoPendiente) mostrarAviso('Se agregó a su carrito');
          avisoPendiente = false;
          pintar();
          // Si el carrito cambió, el resto del tema se entera (por ejemplo, el «en el carrito» de la cantidad de la ficha)
          if (estado.item_count !== piezasAntes && PUB && typeof publish === 'function') {
            publish(PUB.cartUpdate, { source: 'lo-carrito-sin-salir', cartData: estado });
          }
        })
        .catch(function () {});
    }, inmediato ? 0 : 250);
  }

  /* ---------- Cambios hechos por otros botones de la tienda ---------- */
  function urlDe(recurso) {
    if (typeof recurso === 'string') return recurso;
    if (recurso && typeof recurso.url === 'string') return recurso.url;
    return String(recurso || '');
  }

  function rutaDe(url) {
    return String(url).split('?')[0];
  }

  function tocaCarrito(url) {
    var ruta = rutaDe(url);
    return (
      ruta.indexOf('/cart/add') > -1 ||
      ruta.indexOf('/cart/change') > -1 ||
      ruta.indexOf('/cart/update') > -1 ||
      ruta.indexOf('/cart/clear') > -1
    );
  }

  function pideNuestrasSecciones(opciones) {
    var cuerpo = opciones && opciones.body;
    if (!cuerpo) return false;
    try {
      if (typeof FormData !== 'undefined' && cuerpo instanceof FormData) {
        return String(cuerpo.get('sections') || '').indexOf('lo-carrito-estado') > -1;
      }
      if (typeof cuerpo === 'string') return cuerpo.indexOf('lo-carrito-estado') > -1;
    } catch (error) {}
    return false;
  }

  window.fetch = function (recurso, opciones) {
    var promesa = fetchOriginal(recurso, opciones);
    try {
      var metodo = String((opciones && opciones.method) || (recurso && recurso.method) || 'GET').toUpperCase();
      var url = urlDe(recurso);
      if (metodo === 'POST' && tocaCarrito(url) && !pideNuestrasSecciones(opciones)) {
        var alta = rutaDe(url).indexOf('/cart/add') > -1;
        promesa.then(
          function (respuesta) {
            if (respuesta && respuesta.ok) refrescar(alta);
          },
          function () {}
        );
      }
    } catch (error) {}
    return promesa;
  };

  /* ---------- Enlace con assets/product-form.js ---------- */
  if (gancho) {
    gancho.getSectionsToRender = function () {
      return [{ id: 'cart-icon-bubble' }, { id: 'lo-carrito-estado' }];
    };
    gancho.setActiveElement = function (elemento) {
      activoAntes = elemento;
    };
    gancho.renderContents = function (respuesta) {
      alAgregar(respuesta);
    };
  }

  function alAgregar(respuesta) {
    terminarCarga();
    var conSecciones = !!(respuesta && respuesta.sections) && aplicarSecciones(respuesta.sections);
    var primera = respuesta && respuesta.items && respuesta.items.length ? respuesta.items[0] : respuesta;
    var linea = (primera && primera.key && lineaPorClave(primera.key)) || (primera && primera.key ? primera : null);
    if (!conSecciones) refrescar(false);
    pintar();
    abrirHoja(linea);
  }

  function alErrorDelTema(evento) {
    if (Date.now() - desdeBarra > 10000) return;
    desdeBarra = 0;
    terminarCarga();
    var texto = evento && typeof evento.errors === 'string' ? evento.errors : evento && evento.message;
    avisarError(texto || 'No se pudo agregar. Intente de nuevo.');
  }

  /* ---------- Producto de la ficha ---------- */
  function formularioPrincipal() {
    var info =
      document.querySelector('#MainContent product-info[id^="MainProduct-"]') ||
      document.querySelector('#MainContent product-info');
    var pf = info && info.querySelector('product-form');
    return pf ? pf.querySelector('form[action*="/cart/add"]') : null;
  }

  function botonPrincipal() {
    var formulario = formularioPrincipal();
    return formulario ? formulario.querySelector('button[name="add"]') : null;
  }

  function buscarVariante(id) {
    if (!producto || !id) return null;
    for (var i = 0; i < producto.variantes.length; i++) {
      if (String(producto.variantes[i].id) === String(id)) return producto.variantes[i];
    }
    return null;
  }

  function varianteActual() {
    if (!producto) return null;
    var formulario = formularioPrincipal();
    var entrada = formulario && formulario.querySelector('[name="id"]');
    var id = entrada && entrada.value ? entrada.value : null;
    if (!id) {
      try {
        id = new URLSearchParams(window.location.search).get('variant');
      } catch (error) {}
    }
    return buscarVariante(id) || (producto.variantes.length === 1 ? producto.variantes[0] : null);
  }

  function topeDe(variante) {
    return variante && typeof variante.max === 'number' ? Math.max(0, variante.max) : null;
  }

  /* ---------- Día de llegada: misma regla que «Estimación de envío» de la ficha ----------
     Reloj de la tienda (no el del cliente), 3 días hábiles, uno más después de las 2:00 p. m.;
     sin sábados, domingos ni feriados. La lista de feriados debe ser idéntica a la del bloque
     «Estimación de envío» de templates/product.json. Actualizar cada año. */
  var ZONA_TIENDA = 'America/Mexico_City';
  var HORA_CORTE = 14;
  var DIAS_ENVIO = 3;
  var FERIADOS = [
    '2026-01-01', '2026-02-02', '2026-03-16', '2026-04-02', '2026-04-03',
    '2026-05-01', '2026-09-16', '2026-11-16', '2026-12-25',
    '2027-01-01', '2027-02-01', '2027-03-15', '2027-03-25', '2027-03-26',
    '2027-05-01', '2027-09-16', '2027-11-15', '2027-12-25'
  ];
  var DIAS_SEMANA = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function ahoraTienda() {
    try {
      var partes = new Intl.DateTimeFormat('en-CA', {
        timeZone: ZONA_TIENDA,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var valor = function (tipo) {
        for (var i = 0; i < partes.length; i++) if (partes[i].type === tipo) return parseInt(partes[i].value, 10);
        return NaN;
      };
      var hora = { y: valor('year'), m: valor('month'), d: valor('day'), h: valor('hour') % 24 };
      if (!isNaN(hora.y) && !isNaN(hora.m) && !isNaN(hora.d) && !isNaN(hora.h)) return hora;
    } catch (error) {}
    var local = new Date();
    return { y: local.getFullYear(), m: local.getMonth() + 1, d: local.getDate(), h: local.getHours() };
  }

  function claveFecha(fecha) {
    var mes = String(fecha.getMonth() + 1);
    var dia = String(fecha.getDate());
    return fecha.getFullYear() + '-' + (mes.length < 2 ? '0' + mes : mes) + '-' + (dia.length < 2 ? '0' + dia : dia);
  }

  function esHabil(fecha) {
    var dia = fecha.getDay();
    return dia !== 0 && dia !== 6 && FERIADOS.indexOf(claveFecha(fecha)) === -1;
  }

  function diaDeLlegada() {
    var t = ahoraTienda();
    var fecha = new Date(t.y, t.m - 1, t.d);
    var faltan = DIAS_ENVIO + (t.h >= HORA_CORTE ? 1 : 0);
    var vueltas = 0;
    while (faltan > 0 && vueltas++ < 90) {
      fecha.setDate(fecha.getDate() + 1);
      if (esHabil(fecha)) faltan--;
    }
    return DIAS_SEMANA[fecha.getDay()] + ' ' + fecha.getDate();
  }

  function ponerLlegada(nodo) {
    if (!nodo) return;
    var dia = diaDeLlegada();
    if (nodo.getAttribute('data-dia') === dia) return;
    nodo.setAttribute('data-dia', dia);
    nodo.textContent = 'Llega el ';
    var fuerte = document.createElement('b');
    fuerte.textContent = dia;
    nodo.appendChild(fuerte);
  }

  /* ---------- Barra ---------- */
  function plantillaFicha() {
    return (
      '<div class="lo-cs__marco">' +
      '<div class="lo-cs__fila lo-cs__fila--agregar" data-lo-cs="fila-agregar">' +
      '<a class="lo-cs__chip" data-lo-cs="chip" data-lo-cs-carrito hidden>' +
      ICONO.carrito +
      '<span class="lo-cs__burbuja" data-lo-cs="cuenta"></span></a>' +
      '<span class="lo-cs__foto" data-lo-cs="foto-a"><img alt="" width="56" height="56" data-lo-cs="img-a"></span>' +
      '<span class="lo-cs__info">' +
      '<span class="lo-cs__titulo" data-lo-cs="titulo-a"></span>' +
      '<span class="lo-cs__renglon">' +
      '<span class="lo-cs__precio" data-lo-cs="precio"></span>' +
      '<s class="lo-cs__antes" data-lo-cs="antes" hidden></s>' +
      '<span class="lo-cs__nota lo-cs__nota--gratis" data-lo-cs="gratis-a" hidden>' +
      ICONO.camion +
      'Envío gratis</span>' +
      '<span class="lo-cs__llega" data-lo-cs="llega-a" hidden></span>' +
      '</span>' +
      '</span>' +
      '<button type="button" class="lo-cs__agregar" data-lo-cs="agregar">' +
      ICONO.carrito +
      '<span data-lo-cs="agregar-texto">Agregar al carrito</span><span class="lo-cs__espera" aria-hidden="true"></span>' +
      '</button>' +
      '</div>' +
      '<div class="lo-cs__fila lo-cs__fila--carrito" data-lo-cs="fila-carrito" hidden>' +
      '<span class="lo-cs__foto lo-cs__foto--pc" data-lo-cs="foto-c"><img alt="" width="56" height="56" data-lo-cs="img-c"></span>' +
      '<span class="lo-cs__info">' +
      '<span class="lo-cs__titulo" data-lo-cs="titulo-c"></span>' +
      '<span class="lo-cs__estado">' +
      '<span class="lo-cs__ok">' +
      ICONO.palomita +
      'En su carrito</span>' +
      '<span class="lo-cs__total"><span class="lo-cs__etiqueta">Total</span> <b data-lo-cs="total"></b></span>' +
      '<span class="lo-cs__nota" data-lo-cs="nota" hidden></span>' +
      '</span>' +
      '</span>' +
      '<span class="lo-cs__pasos" role="group" aria-label="Cantidad en su carrito">' +
      '<button type="button" class="lo-cs__paso" data-lo-cs="menos"></button>' +
      '<span class="lo-cs__cantidad" data-lo-cs="cantidad" aria-live="polite"></span>' +
      '<button type="button" class="lo-cs__paso" data-lo-cs="mas" aria-label="Agregar una pieza">' +
      ICONO.mas +
      '</button>' +
      '</span>' +
      '<a class="lo-cs__ver" data-lo-cs="ver" data-lo-cs-carrito>Ver carrito' +
      ICONO.flecha +
      '</a>' +
      '</div>' +
      '</div>'
    );
  }

  function plantillaGeneral() {
    return (
      '<div class="lo-cs__marco">' +
      '<div class="lo-cs__fila">' +
      '<a class="lo-cs__chip" data-lo-cs-carrito tabindex="-1" aria-hidden="true">' +
      ICONO.carrito +
      '<span class="lo-cs__burbuja" data-lo-cs="cuenta"></span></a>' +
      '<span class="lo-cs__info">' +
      '<span class="lo-cs__linea" data-lo-cs="linea"></span>' +
      '<span class="lo-cs__total"><span class="lo-cs__etiqueta">Total</span> <b data-lo-cs="total"></b></span>' +
      '<span class="lo-cs__nota" data-lo-cs="nota" hidden></span>' +
      '</span>' +
      '<a class="lo-cs__ver" data-lo-cs="ver" data-lo-cs-carrito>Ver carrito' +
      ICONO.flecha +
      '</a>' +
      '</div>' +
      '</div>'
    );
  }

  function construirBarra() {
    barra.innerHTML = modo === 'ficha' ? plantillaFicha() : plantillaGeneral();
    var nodos = barra.querySelectorAll('[data-lo-cs]');
    for (var i = 0; i < nodos.length; i++) el[nodos[i].getAttribute('data-lo-cs')] = nodos[i];
    var enlaces = barra.querySelectorAll('[data-lo-cs-carrito]');
    for (var j = 0; j < enlaces.length; j++) enlaces[j].setAttribute('href', URL_CARRITO);
    if (/Android/.test(navigator.userAgent || '')) barra.classList.add('lo-cs--android');

    if (modo !== 'ficha') return;
    el['titulo-a'].textContent = producto.titulo || '';
    el['titulo-c'].textContent = producto.titulo || '';
    el.agregar.addEventListener('click', alTocarAgregar);
    el.menos.addEventListener('click', function () {
      cambiarCantidad(-1);
    });
    el.mas.addEventListener('click', function () {
      cambiarCantidad(1);
    });
  }

  function ponerImagen(img, contenedor, src) {
    if (!img) return;
    if (src) {
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      contenedor.classList.remove('lo-cs__foto--vacia');
    } else {
      img.removeAttribute('src');
      contenedor.classList.add('lo-cs__foto--vacia');
    }
  }

  function ponerNota(nodo, nota) {
    if (!nodo) return;
    nodo.hidden = !nota;
    if (!nota) return;
    nodo.className = 'lo-cs__nota lo-cs__nota--' + nota.clase;
    nodo.innerHTML = nota.clase === 'max' ? '' : ICONO.camion;
    nodo.appendChild(document.createTextNode(nota.texto));
  }

  function notaDeEnvio() {
    if (UMBRAL <= 0) return null;
    if (estado.total_price >= UMBRAL) return { clase: 'gratis', texto: 'Envío gratis' };
    return { clase: 'faltan', texto: 'Faltan ' + dinero(UMBRAL - estado.total_price) };
  }

  function pintarFicha() {
    var variante = varianteActual();
    var linea = variante ? lineaDeVariante(variante.id) : null;
    var enCarrito = !!linea && linea.quantity > 0;
    var imagen = (variante && variante.imagen) || producto.imagen || '';
    ponerImagen(el['img-a'], el['foto-a'], imagen);
    ponerImagen(el['img-c'], el['foto-c'], imagen);
    el['fila-agregar'].hidden = enCarrito;
    el['fila-carrito'].hidden = !enCarrito;

    if (!enCarrito) {
      var otros = estado.item_count;
      el.chip.hidden = otros < 1;
      el['fila-agregar'].toggleAttribute('data-otros', otros > 0);
      el.cuenta.textContent = otros > 99 ? '99+' : String(otros);
      el.chip.setAttribute('aria-label', 'Ver carrito: ' + articulos(otros));
      el.precio.textContent = variante ? dinero(variante.precio) : '';
      var rebaja = !!variante && variante.antes > variante.precio;
      el.antes.hidden = !rebaja;
      el.antes.textContent = rebaja ? dinero(variante.antes) : '';
      var gratis = UMBRAL > 0 && !!variante && estado.total_price + variante.precio >= UMBRAL;
      el['gratis-a'].hidden = !gratis;
      el['fila-agregar'].toggleAttribute('data-gratis', gratis);
      var principal = botonPrincipal();
      var agotado = !variante || !variante.disponible || (!!principal && principal.disabled);
      el.agregar.disabled = agotado;
      el['agregar-texto'].textContent = agotado ? 'Agotado' : 'Agregar al carrito';
      el['llega-a'].hidden = agotado;
      if (!agotado) ponerLlegada(el['llega-a']);
    } else {
      var cantidad = clavePedida === linea.key && cantidadPedida !== null ? cantidadPedida : linea.quantity;
      var tope = topeDe(variante);
      el.cantidad.textContent = String(cantidad);
      el.total.textContent = dinero(estado.total_price);
      var nota = tope !== null && cantidad >= tope ? { clase: 'max', texto: 'Máximo disponible' } : notaDeEnvio();
      ponerNota(el.nota, nota);
      var unaPieza = cantidad <= 1;
      el.menos.innerHTML = unaPieza ? ICONO.bote : ICONO.menos;
      el.menos.setAttribute('aria-label', unaPieza ? 'Quitar del carrito' : 'Quitar una pieza');
      el.mas.setAttribute('aria-disabled', tope !== null && cantidad >= tope ? 'true' : 'false');
    }

    mostrarBarra(!oculta && !!botonPrincipal() && (enCarrito || pasado));
  }

  function pintarGeneral() {
    var n = estado.item_count;
    el.cuenta.textContent = n > 99 ? '99+' : String(n);
    if (avisoTexto) {
      el.linea.className = 'lo-cs__linea lo-cs__linea--aviso';
      el.linea.innerHTML = ICONO.palomita;
      el.linea.appendChild(document.createTextNode(avisoTexto));
    } else {
      el.linea.className = 'lo-cs__linea';
      el.linea.textContent = 'Su carrito · ' + articulos(n);
    }
    el.total.textContent = dinero(estado.total_price);
    ponerNota(el.nota, notaDeEnvio());
    mostrarBarra(!oculta && n > 0 && anchoGeneral.matches);
  }

  function mostrarBarra(encender) {
    var antes = barra.classList.contains('visible');
    if (antes !== encender) {
      var conFoco = !encender && barra.contains(document.activeElement);
      barra.classList.toggle('visible', encender);
      barra.setAttribute('aria-hidden', encender ? 'false' : 'true');
      if (encender) barra.removeAttribute('inert');
      else barra.setAttribute('inert', '');
      if (conFoco) enfocar(botonPrincipal());
    }
    document.documentElement.style.setProperty(
      '--lo-cs-alto',
      encender ? Math.ceil(barra.getBoundingClientRect().height) + 'px' : '0px'
    );
    document.body.classList.toggle('lo-cs-con-barra', encender);
  }

  function pintar() {
    if (modo === 'ficha') {
      pintarFicha();
      pintarYaTiene();
    } else if (modo === 'general') {
      pintarGeneral();
    }
    if (hojaAbierta) pintarEnvioHoja();
  }

  function mostrarAviso(texto) {
    if (modo !== 'general') return;
    avisoTexto = texto;
    clearTimeout(esperaAviso);
    esperaAviso = setTimeout(function () {
      avisoTexto = '';
      pintar();
    }, 4000);
    pintar();
  }

  /* ---------- «Agregar al carrito» de la barra: usa el botón principal (misma cantidad y variante) ---------- */
  function alTocarAgregar() {
    var principal = botonPrincipal();
    if (!principal || principal.disabled || el.agregar.disabled || el.agregar.classList.contains('lo-cs--cargando')) return;
    if (principal.getAttribute('aria-disabled') === 'true') return;
    empezarCarga();
    var variante = varianteActual();
    var detalle = { productId: String(producto.id), variantId: variante ? String(variante.id) : '', source: 'sticky_bar' };
    try {
      window.dispatchEvent(new CustomEvent('laobra:sticky_atc', { detail: detalle }));
    } catch (error) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'sticky_add_to_cart', ecommerce: detalle });
    }
    desdeBarra = Date.now();
    principal.click();
  }

  function empezarCarga() {
    el.agregar.classList.add('lo-cs--cargando');
    el.agregar.setAttribute('aria-busy', 'true');
    clearTimeout(esperaCarga);
    esperaCarga = setTimeout(terminarCarga, 8000);
  }

  function terminarCarga() {
    clearTimeout(esperaCarga);
    if (!el.agregar) return;
    el.agregar.classList.remove('lo-cs--cargando');
    el.agregar.removeAttribute('aria-busy');
  }

  /* ---------- Cantidad en el carrito desde la barra ---------- */
  function cambiarCantidad(paso) {
    var variante = varianteActual();
    var linea = variante ? lineaDeVariante(variante.id) : null;
    if (!linea) return;
    var actual = clavePedida === linea.key && cantidadPedida !== null ? cantidadPedida : linea.quantity;
    var tope = topeDe(variante);
    var nueva = Math.max(0, actual + paso);
    if (paso > 0 && tope !== null && nueva > tope) {
      avisarError('Ya no hay más piezas disponibles.');
      return;
    }
    clavePedida = linea.key;
    cantidadPedida = nueva;
    pintar();
    clearTimeout(esperaCambio);
    esperaCambio = setTimeout(enviarCambio, nueva === 0 ? 0 : 350);
  }

  function enviarCambio() {
    if (cantidadPedida === null || !clavePedida) return;
    var clave = clavePedida;
    var cantidad = cantidadPedida;
    barra.classList.add('lo-cs--cambiando');
    fetchOriginal(RAIZ + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad, sections: SECCIONES, sections_url: window.location.pathname })
    })
      .then(function (respuesta) {
        return respuesta
          .json()
          .catch(function () {
            return null;
          })
          .then(function (datos) {
            return { ok: respuesta.ok, codigo: respuesta.status, datos: datos };
          });
      })
      .then(function (resultado) {
        if (clavePedida === clave && cantidadPedida === cantidad) {
          clavePedida = null;
          cantidadPedida = null;
        }
        if (!resultado.ok || !resultado.datos) {
          avisarError(
            resultado.codigo === 422 ? 'Ya no hay más piezas disponibles.' : 'No se pudo cambiar la cantidad. Intente de nuevo.'
          );
          refrescar(false);
          return;
        }
        var carrito = resultado.datos;
        if (!(carrito.sections && aplicarSecciones(carrito.sections)) && carrito.items) estado = normalizar(carrito);
        if (PUB && typeof publish === 'function') {
          publish(PUB.cartUpdate, { source: 'lo-carrito-sin-salir', cartData: carrito });
        }
      })
      .catch(function () {
        clavePedida = null;
        cantidadPedida = null;
        avisarError('No se pudo cambiar la cantidad. Intente de nuevo.');
        refrescar(false);
      })
      .then(function () {
        barra.classList.remove('lo-cs--cambiando');
        pintar();
      });
  }

  /* ---------- Renglón «Ya tiene N en su carrito · Ver carrito» bajo el botón principal ---------- */
  function pintarYaTiene() {
    var variante = varianteActual();
    var linea = variante ? lineaDeVariante(variante.id) : null;
    if (!linea && !yaTiene) return;
    var renglon = asegurarYaTiene();
    if (!renglon) return;
    renglon.hidden = !linea;
    if (linea) renglon.querySelector('[data-lo-cs="ya-texto"]').textContent = 'Ya tiene ' + linea.quantity + ' en su carrito';
  }

  function asegurarYaTiene() {
    if (yaTiene && yaTiene.isConnected) return yaTiene;
    var formulario = formularioPrincipal();
    if (!formulario) return null;
    var ancla = formulario.closest('.lo-compra-fila') || formulario.closest('product-form') || formulario;
    yaTiene = document.createElement('p');
    yaTiene.className = 'lo-cs-ya';
    yaTiene.hidden = true;
    yaTiene.innerHTML =
      ICONO.palomita +
      '<span data-lo-cs="ya-texto"></span><span class="lo-cs-ya__punto" aria-hidden="true">·</span><a>Ver carrito</a>';
    yaTiene.querySelector('a').setAttribute('href', URL_CARRITO);
    ancla.insertAdjacentElement('afterend', yaTiene);
    return yaTiene;
  }

  /* ---------- Ventana «Se agregó a su carrito» ---------- */
  function crearHoja() {
    hoja = document.createElement('div');
    hoja.className = 'lo-cs-hoja';
    hoja.hidden = true;
    hoja.innerHTML =
      '<div class="lo-cs-hoja__velo" data-lo-cs-cerrar></div>' +
      '<div class="lo-cs-hoja__caja" role="dialog" aria-modal="true" aria-labelledby="lo-cs-hoja-titulo" tabindex="-1">' +
      '<div class="lo-cs-hoja__asa" aria-hidden="true"></div>' +
      '<div class="lo-cs-hoja__cabeza">' +
      '<span class="lo-cs-hoja__ok" aria-hidden="true">' +
      ICONO.palomita +
      '</span>' +
      '<h2 class="lo-cs-hoja__titulo" id="lo-cs-hoja-titulo">Se agregó a su carrito</h2>' +
      '<button type="button" class="lo-cs-hoja__cerrar" data-lo-cs-cerrar aria-label="Cerrar">' +
      ICONO.cerrar +
      '</button>' +
      '</div>' +
      '<div class="lo-cs-hoja__producto" data-lo-cs-h="producto">' +
      '<span class="lo-cs-hoja__foto" data-lo-cs-h="foto-caja"><img alt="" width="64" height="64" data-lo-cs-h="foto"></span>' +
      '<span class="lo-cs-hoja__datos">' +
      '<span class="lo-cs-hoja__nombre" data-lo-cs-h="nombre"></span>' +
      '<span class="lo-cs-hoja__opcion" data-lo-cs-h="opcion"></span>' +
      '<span class="lo-cs-hoja__cantidad" data-lo-cs-h="cantidad"></span>' +
      '</span>' +
      '<span class="lo-cs-hoja__importe" data-lo-cs-h="importe"></span>' +
      '</div>' +
      '<p class="lo-cs-hoja__envio" data-lo-cs-h="envio">' +
      ICONO.camion +
      '<span data-lo-cs-h="envio-texto"></span></p>' +
      '<div class="lo-cs-hoja__acciones">' +
      '<button type="button" class="lo-cs-hoja__boton lo-cs-hoja__boton--borde" data-lo-cs-cerrar>Seguir comprando</button>' +
      '<a class="lo-cs-hoja__boton" data-lo-cs-h="carrito">Ver carrito y pagar</a>' +
      '</div>' +
      '</div>';
    document.body.appendChild(hoja);
    hojaCaja = hoja.querySelector('.lo-cs-hoja__caja');
    parteHoja('carrito').setAttribute('href', URL_CARRITO);
    hoja.addEventListener('click', function (evento) {
      if (evento.target.closest && evento.target.closest('[data-lo-cs-cerrar]')) cerrarHoja(false);
    });
    hoja.addEventListener('keydown', function (evento) {
      if (evento.key === 'Escape' || evento.key === 'Esc') {
        evento.preventDefault();
        cerrarHoja(false);
      } else if (evento.key === 'Tab') {
        atraparFoco(evento);
      }
    });
  }

  function parteHoja(nombre) {
    return hoja.querySelector('[data-lo-cs-h="' + nombre + '"]');
  }

  function conAncho(src, ancho) {
    if (!src || src.indexOf('width=') > -1) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }

  function llenarHoja(linea) {
    parteHoja('producto').hidden = !linea;
    if (linea) {
      var src = linea.image || (linea.featured_image && linea.featured_image.url) || '';
      var foto = parteHoja('foto');
      if (src) foto.setAttribute('src', conAncho(src, 160));
      else foto.removeAttribute('src');
      parteHoja('foto-caja').classList.toggle('lo-cs-hoja__foto--vacia', !src);
      parteHoja('nombre').textContent = linea.product_title || linea.title || '';
      var opcion = !linea.product_has_only_default_variant && linea.variant_title ? linea.variant_title : '';
      parteHoja('opcion').textContent = opcion;
      parteHoja('opcion').hidden = !opcion;
      parteHoja('cantidad').textContent = 'Cantidad en su carrito: ' + linea.quantity;
      var importe = typeof linea.final_line_price === 'number' ? linea.final_line_price : linea.line_price;
      parteHoja('importe').textContent = dinero(importe);
    }
    pintarEnvioHoja();
  }

  function pintarEnvioHoja() {
    var renglon = parteHoja('envio');
    var texto = parteHoja('envio-texto');
    renglon.hidden = UMBRAL <= 0;
    if (UMBRAL <= 0) return;
    var gratis = estado.total_price >= UMBRAL;
    renglon.classList.toggle('lo-cs-hoja__envio--gratis', gratis);
    texto.textContent = '';
    var fuerte = document.createElement('b');
    if (gratis) {
      texto.appendChild(document.createTextNode('Su pedido ya tiene '));
      fuerte.textContent = 'envío gratis';
      texto.appendChild(fuerte);
    } else {
      texto.appendChild(document.createTextNode('Le faltan '));
      fuerte.textContent = dinero(UMBRAL - estado.total_price);
      texto.appendChild(fuerte);
      texto.appendChild(document.createTextNode(' para su envío gratis'));
    }
  }

  function abrirHoja(linea) {
    if (!hoja) crearHoja();
    llenarHoja(linea);
    if (!hojaAbierta) {
      hojaAbierta = true;
      hoja.hidden = false;
      void hoja.offsetWidth;
      hoja.classList.add('lo-cs-hoja--abierta');
      document.documentElement.classList.add('lo-cs-hoja-abierta');
      if (window.loAtras) {
        window.loAtras.abrir('lo-cs-hoja', function () {
          cerrarHoja(true);
        });
      }
    }
    setTimeout(function () {
      enfocar(hojaCaja);
    }, 40);
  }

  function cerrarHoja(porAtras) {
    if (!hojaAbierta) return;
    hojaAbierta = false;
    hoja.classList.remove('lo-cs-hoja--abierta');
    document.documentElement.classList.remove('lo-cs-hoja-abierta');
    if (!porAtras && window.loAtras) window.loAtras.cerrar('lo-cs-hoja');
    setTimeout(function () {
      if (!hojaAbierta) hoja.hidden = true;
    }, 360);
    var destino = null;
    if (activoAntes && activoAntes.isConnected && activoAntes.offsetParent !== null && !activoAntes.closest('[inert]')) {
      destino = activoAntes;
    } else if (el.ver && barra.classList.contains('visible') && el.ver.offsetParent !== null) {
      destino = el.ver;
    } else {
      destino = botonPrincipal();
    }
    activoAntes = null;
    enfocar(destino);
  }

  function atraparFoco(evento) {
    var candidatos = hojaCaja.querySelectorAll('button, a[href]');
    var lista = [];
    for (var i = 0; i < candidatos.length; i++) if (candidatos[i].offsetParent !== null) lista.push(candidatos[i]);
    if (!lista.length) return;
    var primero = lista[0];
    var ultimo = lista[lista.length - 1];
    var actual = document.activeElement;
    if (evento.shiftKey && (actual === primero || actual === hojaCaja)) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && actual === ultimo) {
      evento.preventDefault();
      primero.focus();
    }
  }

  function enfocar(elemento) {
    if (!elemento || typeof elemento.focus !== 'function') return;
    try {
      elemento.focus({ preventScroll: true });
    } catch (error) {
      elemento.focus();
    }
  }

  /* ---------- Aviso breve para errores ---------- */
  function avisarError(texto) {
    if (!tostada) {
      tostada = document.createElement('div');
      tostada.className = 'lo-cs-tostada';
      tostada.setAttribute('role', 'status');
      tostada.setAttribute('aria-live', 'polite');
      document.body.appendChild(tostada);
    }
    tostada.textContent = texto;
    void tostada.offsetWidth;
    tostada.classList.add('lo-cs-tostada--visible');
    clearTimeout(esperaTostada);
    esperaTostada = setTimeout(function () {
      tostada.classList.remove('lo-cs-tostada--visible');
    }, 3800);
  }

  /* ---------- Visibilidad de la barra de la ficha ---------- */
  function vigilarBoton() {
    var boton = botonPrincipal();
    if (!boton || boton === ioBoton) return;
    ioBoton = boton;
    if (io) io.disconnect();
    if (!('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(
      function (entradas) {
        var entrada = entradas[entradas.length - 1];
        pasado = !entrada.isIntersecting && entrada.boundingClientRect.bottom < 0;
        pintar();
      },
      { threshold: 0 }
    );
    io.observe(boton);
  }

  function sincronizarPronto() {
    if (sincronizando) return;
    sincronizando = true;
    var paso = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
    paso(function () {
      sincronizando = false;
      if (modo === 'ficha') vigilarBoton();
      pintar();
    });
  }

  /* Con un campo de texto activo (teclado abierto) la barra se retira, como la anterior */
  var CAMPOS =
    'textarea,[contenteditable="true"],input[type="text"],input[type="email"],input[type="tel"],' +
    'input[type="search"],input[type="url"],input[type="password"],input:not([type])';

  function esCampoTexto(elemento) {
    if (!elemento || !elemento.matches) return false;
    if (barra && barra.contains(elemento)) return false;
    if (elemento.closest('form[action*="/cart/add"]')) return false;
    return elemento.matches(CAMPOS);
  }

  /* ---------- Arranque ---------- */
  function quitarBarraAnterior() {
    var repetidas = document.querySelectorAll('[id="custom-sticky-bar"]');
    for (var i = 0; i < repetidas.length; i++) {
      if (repetidas[i] !== barra) repetidas[i].parentNode.removeChild(repetidas[i]);
    }
    var datosViejos = document.getElementById('laobra-variant-data');
    if (datosViejos) datosViejos.parentNode.removeChild(datosViejos);
  }

  function iniciar() {
    if (barra) quitarBarraAnterior();
    if (barra && modo) construirBarra();
    if (modo === 'general') document.body.classList.add('lo-cs-general');

    if (modo === 'ficha') {
      vigilarBoton();
      if (!('IntersectionObserver' in window)) {
        window.addEventListener(
          'scroll',
          function () {
            var boton = botonPrincipal();
            if (!boton) return;
            var nuevo = boton.getBoundingClientRect().bottom < 0;
            if (nuevo !== pasado) {
              pasado = nuevo;
              pintar();
            }
          },
          { passive: true }
        );
      }
      document.addEventListener(
        'change',
        function (evento) {
          if (evento.target && evento.target.name === 'id') sincronizarPronto();
        },
        true
      );
      window.addEventListener('popstate', sincronizarPronto);
      if (PUB && typeof subscribe === 'function') {
        subscribe(PUB.variantChange, sincronizarPronto);
        subscribe(PUB.cartError, alErrorDelTema);
      }
      setTimeout(sincronizarPronto, 1500);
    }

    if (modo) {
      document.addEventListener('focusin', function (evento) {
        if (esCampoTexto(evento.target)) {
          oculta = true;
          pintar();
        }
      });
      document.addEventListener('focusout', function () {
        setTimeout(function () {
          var ahora = esCampoTexto(document.activeElement);
          if (ahora !== oculta) {
            oculta = ahora;
            pintar();
          }
        }, 150);
      });
      if (anchoGeneral.addEventListener) anchoGeneral.addEventListener('change', pintar);
      else if (anchoGeneral.addListener) anchoGeneral.addListener(pintar);
    }

    // Al volver con «atrás» desde el carrito o a la pestaña, el carrito pudo cambiar
    window.addEventListener('pageshow', function (evento) {
      if (evento.persisted) refrescar(false, true);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && Date.now() - ultimoRefresco > 3000) refrescar(false, true);
    });

    pintar();

    // Página abierta con «atrás» sin la caché de páginas (el navegador la arma con el HTML guardado,
    // con el carrito de antes) o precargada antes de cambiar el carrito: se pide el carrito de ahora
    var navegacion =
      window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (navegacion && navegacion.type === 'back_forward') refrescar(false, true);
    if (document.prerendering) {
      document.addEventListener(
        'prerenderingchange',
        function () {
          refrescar(false, true);
        },
        { once: true }
      );
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
